module.exports = __webpack_public_path__ + "img/news-2.4f6b237a.png";